import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { UserMenuService } from 'src/app/core/common-services/user-menu.service';
import { UserService } from 'src/app/core/common-services/user.services';
import { UserMenuItemsOutputDto } from 'src/app/core/data-models/user-permission.data.models';
import { AuthenticationService } from 'src/app/core/data-services/authentication.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
})
export class MenuComponent implements OnInit {
  @Output() anyChange: EventEmitter<any> = new EventEmitter<any>();
  toggleSidebar: boolean = true;
  clicked: boolean = false;
  userName = '';
  userMenu: any[] = [];
  lastExpandedItem?: UserMenuItemsOutputDto;

  userMenuFetchedSubscriber: any;
  constructor(
    private router: Router,
    private userService: UserService,
    private authenticationService: AuthenticationService,
    public usermenuService: UserMenuService
  ) {}

  ngOnInit(): void {
    window.history.pushState(null, '', window.location.href);

    this.userName = this.userService.getUserName()!;
    this.userMenuFetchedSubscriber = this.usermenuService.userMenuFetched.subscribe((menuItems) => {
      this.userMenu = menuItems;
    


    })
    this.usermenuService.fetchUserMenu();
    window.addEventListener('popstate', () => {
      // Redirect to the dashboard if back is attempted
      window.history.pushState(null, '', window.location.href);
    });
  
  }
  toggleMenu(
    menuItem: UserMenuItemsOutputDto,
    sameLevelMenu: UserMenuItemsOutputDto[],
    event: any
  ): void {
    event.stopPropagation();
    menuItem.isExpanded = !menuItem.isExpanded;
    if (menuItem.isExpanded) {
      sameLevelMenu.forEach((item) => {
        if (menuItem.menuId !== item.menuId) {
          item.isExpanded = false;
          this.collapseAllChildren(item);
        }
      });
    } else {
      this.collapseAllChildren(menuItem);
    }
  }

  collapseAllChildren(menuItem: UserMenuItemsOutputDto): void {
    if (menuItem.childItems) {
      menuItem.childItems.forEach((child) => {
        child.isExpanded = false;
        this.collapseAllChildren(child);
      });
    }
  }
  logout() {
    this.userService.logout();
  }
  showSidebar() {
    this.toggleSidebar = !this.toggleSidebar;
  }
  isLoggedIn() {
    return this.userService.isLoggedIn();
  }
  logOut() {
    return this.authenticationService.logout( ).subscribe(() => {
      this.userService.logout();
    });
  }
}
